import styles from './styles.module.scss'
import { Button, Form, Space } from 'antd'
import { useSetupHook } from './hooks'
import BatchUpload from '../../components/BatchUpload'
import RelationProjectCheckGroup from '../../components/RelationProjectCheckGroup'
import SingleUpload from '../../components/SingleUpload'
import SuccessResult from '../../components/SuccessResult'
import MaterialType, {
  BATCH_MATERIAL_LINK,
} from '../../modules/goodsdetailmodules/materialType'
import { materialTypeEnum } from '../../global/enum/product'

export default function NewBatchAdd() {
  const {
    form,
    state,
    singleUploadRef,
    handleDownloadTemplate,
    handleClosePage,
    handleStartImport,
    handleUploadSucceed,
    handleReselectFile,
    handleExcelDel,
    handleFormDataChange,
    handleMaterialTypeChange,
  } = useSetupHook()
  const { importExcelErrorType, showResult, isImportLoading } = state
  const formLayout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 16 },
  }
  return (
    <div className={styles['container']}>
      <SuccessResult
        style={
          !showResult
            ? {
                display: 'none',
              }
            : {}
        }
        onClose={handleClosePage}
      ></SuccessResult>
      <div
        style={
          showResult
            ? {
                display: 'none',
              }
            : {}
        }
      >
        <MaterialType
          form={form}
          type="batch"
          onChange={handleMaterialTypeChange}
          // onChange={validateImportExcelDebouce}
          formItemLayout={formLayout}
        />
        <Form form={form} {...formLayout} onValuesChange={handleFormDataChange}>
          <Form.Item
            label="关联项目"
            name={'relationProject'}
            rules={
              materialTypeEnum.isLabelsMatchValue(
                ['电商供应商物料'],
                form.getFieldValue('productType'),
              )
                ? [{ required: true, message: '请选择关联项目' }]
                : []
            }
          >
            <RelationProjectCheckGroup
              onDownloadTemplate={handleDownloadTemplate}
              mode="single"
              form={form}
              showDownloadTemplate={true}
            ></RelationProjectCheckGroup>
          </Form.Item>
          <Form.Item label="上传图片" name="imgs">
            <BatchUpload />
          </Form.Item>
          <Form.Item
            label="导入物料"
            required
            valuePropName="value"
            name={'file'}
            rules={[
              {
                required: true,
              },
            ]}
            extra={
              <div>
                {importExcelErrorType?.includes('1') ? (
                  <div>
                    <span className="form-error">
                      检测到文件内的项目于当前所选的关联项目不一致！是否
                      <span className="btn-link" onClick={handleReselectFile}>
                        重新选择文件
                      </span>
                    </span>
                  </div>
                ) : null}
                {importExcelErrorType?.includes('2') ? (
                  <div>
                    <span className="form-error">
                      检测到导入文件并非此物料类型的导入模板！请
                      <span className="btn-link" onClick={handleReselectFile}>
                        重新选择文件
                      </span>
                    </span>
                  </div>
                ) : null}
              </div>
            }
          >
            <SingleUpload
              ref={singleUploadRef}
              customProps={{
                tips: (
                  <span>
                    模板填写和上传说明，可以查看
                    <a
                      href={BATCH_MATERIAL_LINK}
                      className="btn-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      商品导入帮助
                    </a>
                  </span>
                ),
                onUploadSucceed: handleUploadSucceed,
                onDel: handleExcelDel,
              }}
            />
          </Form.Item>
        </Form>
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            <Button
              type="primary"
              onClick={handleStartImport}
              className={styles['button-item']}
              loading={isImportLoading}
            >
              开始导入
            </Button>
          </Space>
        </div>
      </div>
    </div>
  )
}
import styles from './styles.module.scss'
import { Button, Form, Space } from 'antd'
import { useSetupHook } from './hooks'
import BatchUpload from '../../components/BatchUpload'
import RelationProjectCheckGroup from '../../components/RelationProjectCheckGroup'
import SingleUpload from '../../components/SingleUpload'
import SuccessResult from '../../components/SuccessResult'
import MaterialType, {
  BATCH_MATERIAL_LINK,
} from '../../modules/goodsdetailmodules/materialType'
import { materialTypeEnum } from '../../global/enum/product'

export default function NewBatchAdd() {
  const {
    form,
    state,
    singleUploadRef,
    handleDownloadTemplate,
    handleClosePage,
    handleStartImport,
    handleUploadSucceed,
    handleReselectFile,
    handleExcelDel,
    handleFormDataChange,
    handleMaterialTypeChange,
  } = useSetupHook()
  const { importExcelErrorType, showResult, isImportLoading } = state
  const formLayout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 16 },
  }
  return (
    <div className={styles['container']}>
      <SuccessResult
        style={
          !showResult
            ? {
                display: 'none',
              }
            : {}
        }
        onClose={handleClosePage}
      ></SuccessResult>
      <div
        style={
          showResult
            ? {
                display: 'none',
              }
            : {}
        }
      >
        <MaterialType
          form={form}
          type="batch"
          onChange={handleMaterialTypeChange}
          // onChange={validateImportExcelDebouce}
          formItemLayout={formLayout}
        />
        <Form form={form} {...formLayout} onValuesChange={handleFormDataChange}>
          <Form.Item
            label="关联项目"
            name={'relationProject'}
            rules={
              materialTypeEnum.isLabelsMatchValue(
                ['电商供应商物料'],
                form.getFieldValue('productType'),
              )
                ? [{ required: true, message: '请选择关联项目' }]
                : []
            }
          >
            <RelationProjectCheckGroup
              onDownloadTemplate={handleDownloadTemplate}
              mode="single"
              form={form}
              showDownloadTemplate={true}
            ></RelationProjectCheckGroup>
          </Form.Item>
          <Form.Item label="上传图片" name="imgs">
            <BatchUpload />
          </Form.Item>
          <Form.Item
            label="导入物料"
            required
            valuePropName="value"
            name={'file'}
            rules={[
              {
                required: true,
              },
            ]}
            extra={
              <div>
                {importExcelErrorType?.includes('1') ? (
                  <div>
                    <span className="form-error">
                      检测到文件内的项目于当前所选的关联项目不一致！是否
                      <span className="btn-link" onClick={handleReselectFile}>
                        重新选择文件
                      </span>
                    </span>
                  </div>
                ) : null}
                {importExcelErrorType?.includes('2') ? (
                  <div>
                    <span className="form-error">
                      检测到导入文件并非此物料类型的导入模板！请
                      <span className="btn-link" onClick={handleReselectFile}>
                        重新选择文件
                      </span>
                    </span>
                  </div>
                ) : null}
              </div>
            }
          >
            <SingleUpload
              ref={singleUploadRef}
              customProps={{
                tips: (
                  <span>
                    模板填写和上传说明，可以查看
                    <a
                      href={BATCH_MATERIAL_LINK}
                      className="btn-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      商品导入帮助
                    </a>
                  </span>
                ),
                onUploadSucceed: handleUploadSucceed,
                onDel: handleExcelDel,
              }}
            />
          </Form.Item>
        </Form>
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            <Button
              type="primary"
              onClick={handleStartImport}
              className={styles['button-item']}
              loading={isImportLoading}
            >
              开始导入
            </Button>
          </Space>
        </div>
      </div>
    </div>
  )
}
